import Marquee from "react-fast-marquee";

const WORDS = ["Proudly Irish", "Globally engaged", "Reasonable Returns", "Philanthropic Focus"];

export default function EditorialMarquee() {
  return (
    <section data-testid="marquee-section" className="border-y border-emerald-900/20 bg-sand/40 py-8 md:py-10">
      <Marquee speed={38} gradient={false} autoFill>
        {WORDS.map((w) => (
          <span key={w} className="mx-8 flex items-center gap-8 font-serif text-2xl md:text-4xl italic text-emerald-900/90">
            {w}
            <span className="text-emerald-900/40 not-italic">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
